import { fetcher } from '@chipinside/fetcher'
import { Moment } from '@chipinside/frontend'
import { MarkdownView } from '@chipinside/markdown'
import { Translate } from '@chipinside/translate'
import { Box, Divider, LinearProgress, Stack, Typography } from '@mui/material'
import React, { useEffect } from 'react'

import { endpoint } from '#/store/services/endpoints'

const style = {
  root: {
    textAlign: 'left',
  },
  box: {
    width: '100%',
    marginBottom: 20,
  },
  title: {
    margin: 0,
  },
}

export default function ReleaseTab(props) {
  const { data, isLoading, setHasNewRelease, setIsOpen, viewed_last_release_note, mutate } = props
  /**
   * Show Orange Gift if not click in "Ok, Entendi"
   */
  useEffect(() => {
    if (viewed_last_release_note === null || viewed_last_release_note?.viewed === false) {
      //Set Icon Orange
      setHasNewRelease(true)
    }
  }, [viewed_last_release_note])

  /**Release Buttons Function */
  function FooterClick(note, type) {
    if (note) {
      const controller =
        type === 'read-later'
          ? endpoint.system.release_notes.read_later({ note })
          : endpoint.system.release_notes.view({ note })

      try {
        fetcher({ method: 'put', controller })
        mutate()

        /**
         * Gray only if click in "Ok Entendi"
         */
        if (!type) {
          setHasNewRelease(false)
        }
      } catch (error) {
        console.error(error)
      }
    }
    setIsOpen(false)
  }

  const FormattedRelease = () =>
    data ? (
      <div style={style.root}>
        <Box style={style.box}>
          <Typography variant="h6" sx={{ color: 'grey.800' }}>
            {Translate({ messageKey: 'your_software_was_updated' })}
          </Typography>
          <Typography sx={{ color: 'grey.800' }}>
            {Translate({
              messageKey: ['version_updated_at', Moment(data?.release_date).format('L')],
              translate: [true, false],
            })}
          </Typography>
        </Box>
        <Divider />
        <Stack spacing={2} sx={{ py: 2, mr: 2 }}>
          <MarkdownView key={'release_note'}>{data.release_note}</MarkdownView>
        </Stack>
      </div>
    ) : (
      <Typography color="textSecondary" component="p" style={{ padding: 20 }}>
        {Translate({ messageKey: 'without_information' })}
      </Typography>
    )

  return {
    key: 'release',
    endpoint: endpoint.system.release_notes.last(),
    onClose: id => FooterClick(id, 'read-later'),
    footer: viewed_last_release_note?.viewed
      ? []
      : [
          {
            text: Translate({ messageKey: 'read_later' }),
            onClick: () => FooterClick(data?.id, 'read-later'),
          },
          {
            text: Translate({ messageKey: 'i_got_it' }),
            onClick: () => FooterClick(data?.id),
            variant: 'contained',
          },
        ],
    content: isLoading ? (
      <LinearProgress key={'linear-progress'} />
    ) : (
      <FormattedRelease key={'formatted-release'} />
    ),
  }
}
